export default "__VITE_ASSET__DMntFBpk__"